import React, { useState, useEffect } from 'react';
import { getAllLockerStatus, subscribeToLockerUpdates } from '../data/firebaseService';
import Header from './Header';
import Footer from './Footer';
import './LockerSelection.css';

const LockerSelection = ({ location, onBack, onLockerSelect }) => {
  const [lockerStatus, setLockerStatus] = useState({});
  const locationLockers = lockerStatus[location] || {};

  // Initialize and set up real-time listener for locker updates
  useEffect(() => {
    const initializeData = async () => {
      try {
        const status = await getAllLockerStatus();
        setLockerStatus(status);
      } catch (error) {
        console.error('Error loading locker status:', error);
      }
    };

    initializeData();
    
    // Set up real-time listener for locker updates
    const unsubscribe = subscribeToLockerUpdates((lockers) => {
      setLockerStatus(lockers);
    });
    
    return () => unsubscribe();
  }, []);

  const locationNames = {
    'rajinder_nagar': 'Rajinder Nagar',
    'patel_nagar': 'Patel Nagar'
  };

  const handleLockerClick = (lockerId) => {
    const locker = locationLockers[lockerId];
    if (locker && locker.status === 'empty') {
      onLockerSelect(location, lockerId);
    }
  };

  const getLockerStatusText = (lockerId) => {
    const locker = locationLockers[lockerId];
    if (!locker) return 'Unknown';
    return locker.status === 'empty' ? 'Available' : 'Occupied';
  };

  const isLockerFull = (lockerId) => {
    const locker = locationLockers[lockerId];
    return locker && locker.status === 'full';
  };

  return (
    <div className="locker-selection">
      <Header />
      <div className="selection-container">
        <div className="selection-header">
          <button className="back-btn" onClick={onBack}>
            ← Back
          </button>
          <h2>🔒 Choose Your Locker</h2>
          <p className="location-info">📍 {locationNames[location]}</p>
        </div>

        <div className="locker-grid">
          <button
            className={`locker-btn ${isLockerFull('locker1') ? 'full' : 'available'}`}
            onClick={() => handleLockerClick('locker1')}
            disabled={isLockerFull('locker1')}
          >
            <div className="locker-icon">{isLockerFull('locker1') ? '🔴' : '🔒'}</div>
            <div className="locker-title">Locker 1</div>
            <div className="locker-status">{getLockerStatusText('locker1')}</div>
            {isLockerFull('locker1') && (
              <div className="full-overlay">
                <span>Locker Full<br/>Please Use Other Locker</span>
              </div>
            )}
          </button>

          <button
            className={`locker-btn ${isLockerFull('locker2') ? 'full' : 'available'}`}
            onClick={() => handleLockerClick('locker2')}
            disabled={isLockerFull('locker2')}
          >
            <div className="locker-icon">{isLockerFull('locker2') ? '🔴' : '🔒'}</div>
            <div className="locker-title">Locker 2</div>
            <div className="locker-status">{getLockerStatusText('locker2')}</div>
            {isLockerFull('locker2') && (
              <div className="full-overlay">
                <span>Locker Full<br/>Please Use Other Locker</span>
              </div>
            )}
          </button>
        </div>

        <div className="instructions">
          <h3>📋 Instructions:</h3>
          <ul>
            <li>Select an available locker to store your clothes</li>
            <li>Full lockers are blurred and cannot be selected</li>
            <li>You'll receive a PIN code after selecting a locker</li>
            <li><strong>ENTER PASSCODE</strong></li>
            <li><strong>PRESS OK AND TURN KNOB TO RIGHT</strong></li>
            <li><strong>Drop/ COLLECT YOUR GARMENTS</strong></li>
            <li><strong>AND TURN KNOB TO TO THE LEFT AND CHECK IF THE LOCKER IS LOCKED</strong></li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LockerSelection; 